import React from 'react';
import profileImage from '../img/profileImage.jpg';

const ProfileImage = () => (
  <div className="profile-image">
    <img src={profileImage} alt="Andrew Baisden" />
  </div>
);

export default ProfileImage;
